import styled, { css } from "styled-components";

const styledModalCheckIn = css`
    width: 75vw;
    min-width: 300px;
    height: 50vh;
    min-height: 550px;
    position: absolute;
    top: 60px;
`;

export const styledModalCheckInMilestone = css`
    width: 75vw;
    min-width: 300px;
    height: 87vh;
    min-height: 550px;
    position: absolute;
    top: 60px;
`;

export const DivCheckInModal = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 8px;
    margin-bottom: 8px;
    border-bottom: 1px solid var(--border-color);
    span{
        font-size: 0.85rem;
    }
    @media(max-width: 576px){
        flex-direction: column;
        justify-content: flex-start;
    }
`;

export default styledModalCheckIn;

